import React from 'react';

import type { Filter } from 'common/types/SortAndFilter';
import { FilterGroupType } from 'common/utils/filterGroups';
import type { FilterChangeParams } from '../context/FilterDrawerContext';
import FilterAccordion from './FilterAccordion';

interface FilterGroupProps {
  type: FilterGroupType;
  name?: string;
  filters: Filter[];
  groupKey: string;
  onFilterChange: (params: FilterChangeParams) => void;
  hideArticlesCount: boolean;
  defaultExpandedSections: string[];
}

const MAX_FILTER_ITEMS_VISIBLE = 5;

const FilterGroup = ({
  type,
  name,
  filters,
  groupKey,
  onFilterChange,
  hideArticlesCount,
  defaultExpandedSections,
}: FilterGroupProps) => {
  const props = {
    filters,
    onFilterChange,
    hideArticlesCount,
    defaultExpandedSections,
    maxItemsVisible: MAX_FILTER_ITEMS_VISIBLE,
  };

  return (
    <div>
      {type === FilterGroupType.Grouped ? (
        <FilterAccordion {...props} groupName={name} groupKey={groupKey} />
      ) : (
        <FilterAccordion {...props} />
      )}
    </div>
  );
};

export default FilterGroup;
